import React from 'react';

import PropTypes from 'prop-types';
import { Fragment } from 'react';

import AdminHeader from './admin-header';
import BackToPage from './back-to-page';

const baseStyles = {
  alignment: {
    display: 'flex',
    flexDirection: 'column',
  },
};

const AdminLayoutHelper = (props) => {
  const alignmentStyle = Object.assign({}, baseStyles.alignment, props.alignmentStyle);
  return (
    <Fragment>
      <section style={alignmentStyle}>
        <BackToPage text={props.page} link={props.link} />
        <AdminHeader header={props.header} />
        {props.children}
      </section>
    </Fragment>
  );
};

AdminLayoutHelper.defaultProps = {
  header: 'Settings',
  alignmentStyle: {},
  page: 'Settings',
};

AdminLayoutHelper.propTypes = {
  page: PropTypes.string,
  header: PropTypes.string,
  alignmentStyle: PropTypes.object,
};

export default AdminLayoutHelper;
